import { render, staticRenderFns } from "./FeaturedCars.vue?vue&type=template&id=45b97630&scoped=true&"
import script from "./FeaturedCars.vue?vue&type=script&lang=js&"
export * from "./FeaturedCars.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedCars.vue?vue&type=style&index=0&id=45b97630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b97630",
  null
  
)

export default component.exports